<template>
  <v-app>
    <SalesAgentHeader />
    <v-main :style="mainStyles">
      <div class="share-section" :class="{ 'dark-mode': isDarkMode }">
        <v-container class="share-container">
          <v-row align="center">
            <v-col cols="12" md="6">
              <h2 class="share-title"><v-icon class="material-icons-round mr-2" :color="isDarkMode ? 'green' : 'white'">share</v-icon>Share Your Dealer Referral Link</h2>
              <p class="share-subtitle">Invite dealerships to join your network and earn commissions on their sales.</p>
            </v-col>
            <v-col cols="12" md="6">
              <div class="share-link-box" :class="{ 'dark-box': isDarkMode }">
                <v-text-field v-model="dealerReferralLink" readonly outlined dense hide-details class="share-input"></v-text-field>
                <div class="share-actions mt-3">
                  <v-btn color="#10b981" dark class="text-none mr-2" @click="copyLink"><v-icon small left class="material-icons-round">content_copy</v-icon>Copy Link</v-btn>
                  <v-btn outlined color="#10b981" class="text-none" @click="shareLink"><v-icon small left class="material-icons-round">share</v-icon>Share</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="dealerships-section" :class="{ 'dark-mode': isDarkMode }">
        <v-container class="dealerships-container">
          <div class="section-header mb-4">
            <h2 class="section-title"><v-icon class="material-icons-round mr-2" :color="isDarkMode ? 'white' : 'grey darken-2'">store</v-icon>Your Dealership Network</h2>
            <v-chip small :color="isDarkMode ? 'green darken-1' : 'green'" dark>{{ dealerReferrals.length }} Dealerships</v-chip>
          </div>
          <v-row class="mb-4">
            <v-col cols="12" sm="4">
              <v-card class="stat-card" :class="{ 'dark-card': isDarkMode }">
                <div class="stat-icon green-bg"><v-icon class="material-icons-round" color="white">store</v-icon></div>
                <div class="stat-content"><div class="stat-value">{{ dealerReferrals.length }}</div><div class="stat-label">Total Dealerships</div></div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card class="stat-card" :class="{ 'dark-card': isDarkMode }">
                <div class="stat-icon teal-bg"><v-icon class="material-icons-round" color="white">check_circle</v-icon></div>
                <div class="stat-content"><div class="stat-value">{{ activeDealerships }}</div><div class="stat-label">Active</div></div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card class="stat-card" :class="{ 'dark-card': isDarkMode }">
                <div class="stat-icon purple-bg"><v-icon class="material-icons-round" color="white">trending_up</v-icon></div>
                <div class="stat-content"><div class="stat-value">{{ tierPercentage }}%</div><div class="stat-label">Your Commission Rate</div></div>
              </v-card>
            </v-col>
          </v-row>
          <v-card class="table-card" :class="{ 'dark-card': isDarkMode }">
            <v-card-title class="d-flex justify-space-between align-center">
              <span>All Dealerships</span>
              <v-text-field v-model="search"  label="Search" single-line hide-details dense outlined style="max-width: 300px;" :dark="isDarkMode"></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="dealerReferrals" :search="search" :loading="loading" class="dealership-table" :class="{ 'dark-table': isDarkMode }" :dark="isDarkMode">
              <template v-slot:item.business_name="{ item }">
                <div class="d-flex align-center">
                  <v-avatar size="36" class="mr-3" :color="isDarkMode ? 'green darken-1' : 'green lighten-4'"><span :class="isDarkMode ? 'white--text' : 'green--text text--darken-2'" style="font-weight: 600;">{{ (item.business_name || 'D').charAt(0) }}</span></v-avatar>
                  <span class="font-weight-medium">{{ item.business_name || 'Unknown' }}</span>
                </div>
              </template>
              <template v-slot:item.location="{ item }">{{ getStateCode(item.location) || item.location || '-' }}</template>
              <template v-slot:item.dealer_payout="{ item }">${{ item.dealer_payout || 0 }}</template>
              <template v-slot:item.agent_tier_percentage="{ item }">{{ item.agent_tier_percentage || tierPercentage }}%</template>
              <template v-slot:item.status="{ item }"><v-chip small :color="getStatusColor(item.status)" dark>{{ item.status || 'Active' }}</v-chip></template>
              <template v-slot:item.created_at="{ item }">{{ formatDate(item.created_at) }}</template>
              <template v-slot:no-data>
                <div class="text-center pa-8"><v-icon size="64" class="material-icons-round mb-4" color="grey">store</v-icon><h3 class="grey--text mb-2">No dealerships yet</h3><p class="grey--text text-caption">Share your referral link to start building your network</p></div>
              </template>
            </v-data-table>
          </v-card>
        </v-container>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Vue from 'vue';
import SalesAgentHeader from '@/components/Layout/SalesAgentHeader.vue';
export default {
  name: 'DealershipSignups',
  components: { SalesAgentHeader },
  data() {
    return {
      loading: true, isDarkMode: true, search: '', dealerReferrals: [], dealerTierInfo: null, user_id: localStorage.getItem('user_id'), client: {}, dealerReferralLink: '',
      headers: [{ text: 'Dealership', value: 'business_name' }, { text: 'Location', value: 'location' }, { text: 'Dealer Payout', value: 'dealer_payout' }, { text: 'Your %', value: 'agent_tier_percentage' }, { text: 'Status', value: 'status' }, { text: 'Joined', value: 'created_at' }],
      header: { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } }
    };
  },
  computed: {
    mainStyles() {
      const b = { padding: '0px!important', marginTop: '70px' };
      return this.isDarkMode ? { ...b, backgroundColor: '#0d1426', backgroundImage: "url('" + require('@/assets/img/skyline-bg-dark.png') + "')", backgroundPosition: 'bottom center', backgroundRepeat: 'repeat-y', backgroundSize: '100% auto', minHeight: 'calc(100vh - 70px)' } : b;
    },
    activeDealerships() { return this.dealerReferrals.filter(d => !d.status || d.status === 'active' || d.status === 'approved').length; },
    tierPercentage() { return this.dealerTierInfo ? this.dealerTierInfo.commission_percentage : 10; }
  },
  mounted() { this.loadDarkModePreference(); this.getUserProfile(); this.getDealerReferralData(); window.addEventListener('salesAgentDarkModeChanged', this.handleDarkModeChange); },
  beforeDestroy() { window.removeEventListener('salesAgentDarkModeChanged', this.handleDarkModeChange); },
  methods: {
    loadDarkModePreference() { this.isDarkMode = localStorage.getItem('sales_agent_dark_mode') !== 'false'; },
    handleDarkModeChange(e) { this.isDarkMode = e.detail.isDarkMode; },
    async getUserProfile() { try { this.client = (await axios.get("/api/get-client/" + this.user_id, this.header)).data.data; this.generateDealerReferralLink(); } catch (e) { console.error(e); } },
    async getDealerReferralData() { this.loading = true; try { const r = await axios.get('/api/agent-dealer-tier/dashboard', this.header); if (r.data.flag === 1) { this.dealerReferrals = r.data.data.referred_dealers || []; this.dealerTierInfo = r.data.data.tier_info || null; } } catch (e) { console.error(e); } finally { this.loading = false; } },
    generateDealerReferralLink() { this.dealerReferralLink = `${window.location.origin}/dealers/signup?ref=${this.user_id}`; },
    copyLink() { navigator.clipboard.writeText(this.dealerReferralLink); Vue.$toast.success('Link copied!', { position: 'top-right' }); },
    shareLink() { navigator.share ? navigator.share({ title: 'Join as a Dealer', url: this.dealerReferralLink }) : this.copyLink(); },
    getStateCode(l) { if (!l) return null; const m = l.match(/,\s*([A-Z]{2})(?:\s|$)/i); return m ? m[1].toUpperCase() : l.substring(0, 2).toUpperCase(); },
    getStatusColor(s) { return (!s || s === 'active' || s === 'approved') ? 'green' : s === 'pending' ? 'orange' : 'grey'; },
    formatDate(d) { return d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '-'; }
  }
};
</script>

<style scoped>
.share-section { padding: 30px 0; background: linear-gradient(135deg, #10b981 0%, #059669 100%); }
.share-section.dark-mode { background: rgba(16, 185, 129, 0.1); border-bottom: 1px solid rgba(16, 185, 129, 0.2); }
.share-container { max-width: 1280px; }
.share-title { color: white; font-size: 24px; font-weight: 700; margin-bottom: 8px; display: flex; align-items: center; }
.dark-mode .share-title { color: #10b981; }
.share-subtitle { color: rgba(255,255,255,0.9); font-size: 14px; margin: 0; }
.dark-mode .share-subtitle { color: rgba(255,255,255,0.7); }
.share-link-box { background: rgba(255,255,255,0.15); border-radius: 12px; padding: 20px; }
.share-link-box.dark-box { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); }
.share-input ::v-deep .v-input__slot { background: white !important; }
.dark-box .share-input ::v-deep .v-input__slot { background: rgba(255,255,255,0.1) !important; }
.dark-box .share-input ::v-deep input { color: white !important; }
.dealerships-section { padding: 40px 0; min-height: calc(100vh - 200px); }
.dealerships-section:not(.dark-mode) { background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%); }
.dealerships-section.dark-mode { background: transparent; }
.dealerships-container { max-width: 1280px; }
.section-header { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px; }
.section-title { font-size: 24px; font-weight: 700; margin: 0; display: flex; align-items: center; }
.dark-mode .section-title { color: white; }
.stat-card { display: flex; align-items: center; padding: 20px; border-radius: 12px; }
.stat-card.dark-card { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); }
.stat-icon { width: 50px; height: 50px; border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-right: 16px; }
.green-bg { background: linear-gradient(135deg, #10b981 0%, #059669 100%); }
.teal-bg { background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%); }
.purple-bg { background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%); }
.stat-value { font-size: 28px; font-weight: 700; line-height: 1.2; }
.dark-card .stat-value { color: white; }
.stat-label { font-size: 13px; color: #64748b; margin-top: 4px; }
.dark-card .stat-label { color: rgba(255,255,255,0.6); }
.table-card { border-radius: 12px; overflow: hidden; }
.table-card.dark-card { background: rgba(13, 20, 38, 0.95) !important; border: 1px solid rgba(255,255,255,0.08); }
.dark-card ::v-deep .v-card__title { color: white; background: transparent !important; }
.dark-table.theme--dark.v-data-table { background: transparent !important; }
.dark-table ::v-deep .v-data-table { background: transparent !important; }
.dark-table ::v-deep .v-data-table__wrapper { background: transparent !important; }
.dark-table ::v-deep table { background: transparent !important; }
.dark-table ::v-deep thead { background: rgba(255,255,255,0.03) !important; }
.dark-table ::v-deep th { color: rgba(255,255,255,0.7) !important; background: transparent !important; border-bottom: 1px solid rgba(255,255,255,0.1) !important; }
.dark-table ::v-deep tbody { background: transparent !important; }
.dark-table ::v-deep tbody tr { background: transparent !important; }
.dark-table ::v-deep tbody tr:hover { background: rgba(255,255,255,0.05) !important; }
.dark-table ::v-deep td { color: rgba(255,255,255,0.9) !important; background: transparent !important; border-bottom: 1px solid rgba(255,255,255,0.08) !important; }
.dark-table ::v-deep .v-data-footer { background: transparent !important; color: rgba(255,255,255,0.7) !important; border-top: 1px solid rgba(255,255,255,0.08) !important; }
.dark-table ::v-deep .v-data-footer .v-select__selection { color: rgba(255,255,255,0.7) !important; }
.dark-table ::v-deep .v-data-footer .v-icon { color: rgba(255,255,255,0.5) !important; }
.dark-table ::v-deep .v-data-footer .v-btn--disabled .v-icon { color: rgba(255,255,255,0.2) !important; }
.dark-card ::v-deep .v-text-field--outlined fieldset { border-color: rgba(255,255,255,0.3) !important; }
.dark-card ::v-deep .v-text-field--outlined:hover fieldset { border-color: rgba(255,255,255,0.5) !important; }
.dark-card ::v-deep .v-label { color: rgba(255,255,255,0.7) !important; }
</style>